import React from "react";
import PopupWrapper from "../popupWrapper/popupWrapper";
import { popupTexts } from "../../utils/constants";
import "./warningPopup.css";

const WarningPopup = ({ onClose, onConfirm, warningAction }) => {
  return (
    <PopupWrapper onClose={onClose}>
      <div className="warning_popup">
        <p className="warning_header">
          {warningAction === "credentials"
            ? popupTexts.credentials_email_header
            : popupTexts.warning_header}
        </p>
        <p className="warning_subheader">
          {warningAction === "credentials"
            ? popupTexts.credentials_email_subheader
            : popupTexts.warning_subheader}
        </p>
        <div className="warning_button_section">
          <button className="button reject reject_btn " onClick={onClose}>
            {popupTexts.cancel_btn}
          </button>
          <button className="button accept accept_btn " onClick={onConfirm}>
            {popupTexts.warning_confirm_btn}
          </button>
        </div>
      </div>
    </PopupWrapper>
  );
};

export default WarningPopup;
